/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var carousel = document.querySelector('.AnnouncementBar__Wrapper.slider');
var flkty = new Flickity( carousel, {
  wrapAround: true,
  pauseAutoPlayOnHover: true,
  autoPlay: true,
  autoPlay: 4500,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: false,
  cellAlign: 'center'
});

var carouselugc = document.querySelector('.carouselugc');
var flkty = new Flickity( carouselugc, {
  wrapAround: true,
  pauseAutoPlayOnHover: true,
  autoPlay: false,
  prevNextButtons: true,
  pageDots: false,
  percentPosition: false,
  cellAlign: 'left'
});

var carouselugc = document.querySelector('.carouselugctwo');
var flkty = new Flickity( carouselugc, {
  wrapAround: true,
  pauseAutoPlayOnHover: true,
  autoPlay: false,
  prevNextButtons: true,
  pageDots: false,
  percentPosition: false,
  cellAlign: 'left'
});

let footerMenu = [...document.getElementsByClassName('footer_open_menu')].forEach(e => {
    e.addEventListener('click', (el) => {
        el.target.parentNode.classList.toggle('active')
    })
})


document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementsByClassName('add-basket-scroll').length){
    const addBasketScroll = document.querySelector('.add-basket-scroll')
    if (window.matchMedia("(min-width: 768px)").matches) {
      const addToBasketButton = document.getElementById('stamped-main-widget')
  
      if (addBasketScroll) {
        window.addEventListener('scroll', function () {
          if (window.scrollY > addToBasketButton.offsetTop) {
            addBasketScroll.classList.add('translate-y-0')
            addBasketScroll.classList.remove('translate-y-full')
          } else {
            addBasketScroll.classList.remove('translate-y-0')
            addBasketScroll.classList.add('translate-y-full')
          }
    
          if (
            window.innerHeight + window.pageYOffset >=
            document.body.offsetHeight
          ) {
            addBasketScroll.classList.remove('translate-y-0')
            addBasketScroll.classList.add('translate-y-full')
          }
        })
      }
    } else {
      const addToBasketButton = document.getElementById('Product__InfoAside')
  
      if (addBasketScroll) {
        window.addEventListener('scroll', function () {
          if (window.scrollY > addToBasketButton.offsetTop) {
            addBasketScroll.classList.add('translate-y-0')
            addBasketScroll.classList.remove('translate-y-full')
          } else {
            addBasketScroll.classList.remove('translate-y-0')
            addBasketScroll.classList.add('translate-y-full')
          }
    
          if (
            window.innerHeight + window.pageYOffset >=
            document.body.offsetHeight
          ) {
            addBasketScroll.classList.remove('translate-y-0')
            addBasketScroll.classList.add('translate-y-full')
          }
        })
      }
    }
  
    var fakeButton = document.getElementById("docked-add-to-cart");
    var realButton = document.getElementById("add-to-cart-btn");
   
    fakeButton.addEventListener('click', () => {
      realButton.click();
    })
  }
})

const ul = document.querySelector('ul');
ul.addEventListener('click', e => {
  const { target } = e;
  if (target.matches('li')) {
    callback(); // If target is an li, run callback
  }
});


  
  document.addEventListener('click', e => {
      
      var Cart__DiscountButton = document.querySelector(".Cart__DiscountButton");
      var Cart__DiscountBlock = document.querySelector(".Cart__DiscountBlock");
      var Cart__DiscountClose = document.querySelector(".close_discount");
  
      console.log(Cart__DiscountButton);
  
      Cart__DiscountButton.addEventListener('click', () => {  
        Cart__DiscountBlock.classList.add('translate-y-0')
        Cart__DiscountBlock.classList.remove('translate-y-full')
      })
      Cart__DiscountClose.addEventListener('click', () => {
        Cart__DiscountBlock.classList.remove('translate-y-0')
        Cart__DiscountBlock.classList.add('translate-y-full')
      })
    
  })
